import React, { useMemo } from 'react';
import { resolveSessionDateTimeDisplay } from '../../utils/sessionDateTimeDisplay';

/**
 * Centered 3-row session timing:
 *   05/13/2026
 *   05:00 PM - 06:00 PM
 *   (60 minutes)
 */
const SessionDateTimeDisplay = ({
  dateTime,
  date,
  timeRange,
  duration,
  startTime,
  endTime,
  className = '',
}) => {
  const parts = useMemo(
    () => resolveSessionDateTimeDisplay({ dateTime, date, timeRange, duration, startTime, endTime }),
    [dateTime, date, timeRange, duration, startTime, endTime]
  );

  if (!parts) {
    return <span className={`text-gray-400 ${className}`.trim()}>—</span>;
  }

  const durationText = parts.duration
    ? (parts.duration.startsWith('(') ? parts.duration : `(${parts.duration})`)
    : null;

  return (
    <div className={`flex flex-col items-center justify-center text-center gap-0.5 ${className}`.trim()}>
      {parts.date ? (
        <div className="text-sm font-medium text-gray-900 leading-snug">{parts.date}</div>
      ) : null}
      {parts.timeRange ? (
        <div className="text-sm text-gray-600 leading-snug">{parts.timeRange}</div>
      ) : null}
      {durationText ? (
        <div className="text-xs text-gray-500 leading-snug">{durationText}</div>
      ) : null}
    </div>
  );
};

export default SessionDateTimeDisplay;
